import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const language = [
    { name: "English", flags: "united-states" },
    { name: "English ( United Kingdom )", flags: "united-kingdom" },
    { name: "Espanol", flags: "spain" },
    { name: "Deutsch", flags: "germany" }
];

const LanguageListBox = () => {
    const [selected, setSelected] = useState(language[0]);
    return (
        <div className="mt-8 phone:mt-6 w-full tablet:w-[276px] desktop:w-[276px]">
            <Listbox value={selected} onChange={setSelected}>
                <div className="relative mt-1">
                    <Listbox.Button className="relative h-[48px] w-full border border-[#F9F9FB] focus:border focus:border-primary-main flex items-center cursor-default rounded-lg bg-[#F9F9FB] py-[14px] px-4 text-left focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                        <img src={`/images/homepage/flags/${selected.flags}.svg`} width="20px" height="15px" alt={selected.flags} />
                        <span className="block truncate ml-3 font-semibold text-[16px] text-primary-dark leading-[19.83px]">{selected.name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronDownIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className="absolute z-50 mt-1 max-h-48 w-full overflow-auto rounded-lg font-normal bg-neutral-10 py-1 text-base shadow-sm ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {language.map((lang, langIdx) => (
                                <Listbox.Option
                                    key={langIdx}
                                    className={({ active }) =>
                                        `relative cursor-default select-none pb-2 pl-4 font-normal pr-4 ${active ? "bg-primary-surface text-primary-main" : "text-primary-dark bg-neutral-10"
                                        }`
                                    }
                                    value={lang}
                                >
                                    {({ selected }) => (
                                        <div className="flex items-center space-x-3 pb-2">
                                            <img src={`/images/homepage/flags/${lang.flags}.svg`} width="20px" height="15px" alt={lang.flags} />
                                            <span
                                                className={`block text-md truncate ${selected ? "font-medium" : "font-normal"
                                                    }`}
                                            >
                                                {lang.name}
                                            </span>
                                        </div>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    );
};

export default LanguageListBox;